module.exports = __webpack_public_path__ + "static/media/teamAdmin_steve.2ecbb486.svg";